/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import usePatchInsightReview from "hookMutation/usePatchInsightReview";
import { h100css } from "assets/css/dimensions";
import "./index.css";

export default function ReviewStatusCell({ row, getValue }) {
  const currentStatus = getValue() || "not_reviewed";
  const insightId = row.original.documentId;

  const { mutate } = usePatchInsightReview();

  const handleStatusClick = (clickedStatus) => {
    const nextStatus = currentStatus === clickedStatus ? "not_reviewed" : clickedStatus;

    mutate({ id: insightId, status: nextStatus });
  };

  const getButtonStyle = (status) => {
    if (currentStatus !== status) return "group-button";
    return status === "insightful"
      ? "group-button active-insightful"
      : "group-button active-not-insightful";
  };
  return (
    <span className="button-group-container flex-a-c-j-c" css={h100css}>
      <button
        type="button"
        className={getButtonStyle("insightful")}
        onClick={() => handleStatusClick("insightful")}
      >
        Insightful
      </button>
      <button
        type="button"
        className={getButtonStyle("not_insightful")}
        onClick={() => handleStatusClick("not_insightful")}
      >
        Not Insightful
      </button>
    </span>
  );
}

ReviewStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      documentId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  getValue: PropTypes.func,
};
